!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports["react-role"] = t(require("react")) : e["react-role"] = t(e.react);
}(this, function (e) {
  return function () {
    "use strict";

    var t = {
      156: function _(t) {
        t.exports = e;
      }
    },
        r = {};

    function n(e) {
      var o = r[e];
      if (void 0 !== o) return o.exports;
      var i = r[e] = {
        exports: {}
      };
      return t[e](i, i.exports, n), i.exports;
    }

    n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, {
        a: t
      }), t;
    }, n.d = function (e, t) {
      for (var r in t) {
        n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
          enumerable: !0,
          get: t[r]
        });
      }
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var o = {};
    return function () {
      n.r(o), n.d(o, {
        HasAccess: function HasAccess() {
          return r;
        },
        PermifyContext: function PermifyContext() {
          return s;
        },
        PermifyProvider: function PermifyProvider() {
          return f;
        },
        usePermify: function usePermify() {
          return u;
        }
      });
      var e = n(156),
          t = n.n(e);

      var r = function r(t) {
        var r = t.roles,
            n = t.permissions,
            o = t.isLoading,
            i = t.renderAuthFailed,
            s = t.children,
            u = (0, e.useState)(!1),
            l = u[0],
            a = u[1],
            c = (0, e.useState)(!1),
            f = c[0],
            d = c[1];
        return (0, e.useEffect)(function () {
          var e = JSON.parse(localStorage.getItem("__permifyUser"));
          e ? (d(!0), r && e.roles && e.roles.length > 0 && e.roles.filter(function (e) {
            return r.includes(e);
          }).length > 0 && a(!0), n && e.permissions && e.permissions.length > 0 && e.permissions.filter(function (e) {
            return n.includes(e);
          }).length > 0 && a(!0), d(!1)) : console.log("No user provided to Permify! You should set user to perfom access check");
        }, [r, n]), !l && f ? o : l ? e.createElement(e.Fragment, null, s) : i || null;
      };

      var i = function i() {
        throw new Error("You didn't set User!");
      };

      var s = (0, e.createContext)({
        setUser: i,
        isAuthorized: i,
        isLoading: !1
      }),
          u = function u() {
        return (0, e.useContext)(s);
      };

      var l = function l(e, t, r, n) {
        return new (r || (r = Promise))(function (o, i) {
          function s(e) {
            try {
              l(n.next(e));
            } catch (e) {
              i(e);
            }
          }

          function u(e) {
            try {
              l(n.throw(e));
            } catch (e) {
              i(e);
            }
          }

          function l(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
              e(t);
            })).then(s, u);
          }

          l((n = n.apply(e, t || [])).next());
        });
      },
          a = function a(e, t) {
        var r,
            n,
            o,
            i,
            s = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
        return i = {
          next: u(0),
          throw: u(1),
          return: u(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;

        function u(i) {
          return function (u) {
            return function (i) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; s;) {
                try {
                  if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

                  switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                    case 0:
                    case 1:
                      o = i;
                      break;

                    case 4:
                      return s.label++, {
                        value: i[1],
                        done: !1
                      };

                    case 5:
                      s.label++, n = i[1], i = [0];
                      continue;

                    case 7:
                      i = s.ops.pop(), s.trys.pop();
                      continue;

                    default:
                      if (!((o = (o = s.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                        s = 0;
                        continue;
                      }

                      if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                        s.label = i[1];
                        break;
                      }

                      if (6 === i[0] && s.label < o[1]) {
                        s.label = o[1], o = i;
                        break;
                      }

                      if (o && s.label < o[2]) {
                        s.label = o[2], s.ops.push(i);
                        break;
                      }

                      o[2] && s.ops.pop(), s.trys.pop();
                      continue;
                  }

                  i = t.call(e, s);
                } catch (e) {
                  i = [6, e], n = 0;
                } finally {
                  r = o = 0;
                }
              }

              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, u]);
          };
        }
      },
          c = "__permifyUser";

      var f = function f(r) {
        var n = r.children,
            o = (0, e.useState)(!1),
            i = o[0],
            u = o[1],
            f = (0, e.useCallback)(function (e, t) {
          return l(void 0, void 0, void 0, function () {
            var r, n;
            return a(this, function (o) {
              switch (o.label) {
                case 0:
                  return r = !1, n = JSON.parse(localStorage.getItem(c)), u(!0), n ? [4, d(n, e, t)] : [3, 2];

                case 1:
                  r = o.sent(), o.label = 2;

                case 2:
                  return u(!1), [2, r];
              }
            });
          });
        }, []),
            d = function d(e, t, r) {
          return l(void 0, void 0, void 0, function () {
            var n, o, i, s, u;
            return a(this, function (l) {
              return n = !1, o = !1, e.roles && t && e.roles.length > 0 && (i = e.roles, u = i.filter(function (e) {
                return t.includes(e);
              }), n = u.length > 0), e.permissions && r && e.permissions.length > 0 && (s = e.permissions, u = s.filter(function (e) {
                return r.includes(e);
              }), o = u.length > 0), [2, n || o];
            });
          });
        };

        return t().createElement(s.Provider, {
          value: {
            setUser: function setUser(e) {
              localStorage.setItem(c, JSON.stringify(e));
            },
            isAuthorized: f,
            isLoading: i
          }
        }, n);
      };
    }(), o;
  }();
});